import { useEffect } from 'react';
import { Bot, MessageCircle, Send } from 'lucide-react';

interface InfoResearchChatProps {
  isOpen: boolean;
  onClose: () => void;
}

export function InfoResearchChat({ isOpen, onClose }: InfoResearchChatProps) {
  useEffect(() => {
    if (!isOpen) return;
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    return () => {
      const top = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (top) {
        window.scrollTo(0, parseInt(top || '0') * -1);
      }
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start sm:items-center justify-center p-0 sm:p-4 z-[9998]">
      <div className="bg-white dark:bg-gray-800 rounded-none sm:rounded-2xl shadow-2xl w-full max-w-3xl h-full max-h-[calc(100dvh-64px)] sm:h-[calc(85vh-80px)] flex flex-col overflow-hidden md:mb-0 mb-16">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-2 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center space-x-3">
            <MessageCircle className="w-6 h-6 text-blue-500" />
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Исследование инфоповодов</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">Подбор актуальных инфоповодов в вашей нише</p>
            </div>
          </div>
          <div className="flex space-x-2 w-full sm:w-auto justify-end">
            <button
              onClick={onClose}
              className="px-2 sm:px-3 py-1 text-xs sm:text-sm bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-200 rounded hover:bg-gray-300 dark:hover:bg-gray-500 transition-colors"
            >
              Закрыть окно
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-4">
          <div className="flex justify-start">
            <div className="flex items-start space-x-2 max-w-sm lg:max-w-xl">
              <Bot className="w-6 h-6 text-blue-500 flex-shrink-0" />
              <div className="px-4 py-2 rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white">
                <div className="text-sm whitespace-pre-wrap">
                  Скоро будет доступно исследование инфоповодов в вашей сфере. Мы готовим инструмент, который будет находить актуальные тренды, события и инсайты специально под вашу нишу.
                </div>
                <p className="text-xs mt-1 opacity-70">AI • сейчас</p>
              </div>
            </div>
          </div>
        </div>

        <div className="p-3 border-t border-gray-200 dark:border-gray-700">
          <div className="flex items-center space-x-2 opacity-60">
            <input
              type="text"
              disabled
              placeholder="Скоро вы сможете задать вопрос..."
              className="flex-1 px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-300"
            />
            <button disabled className="p-2 bg-gray-300 dark:bg-gray-600 text-white rounded-lg cursor-not-allowed h-10 w-10 flex items-center justify-center">
              <Send className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoResearchChat;


